import React, { useEffect } from 'react';

const RedirectToParticipantHome = (): React.ReactElement => {
  useEffect(() => {
    const shouldRedirect = true;

    if (shouldRedirect) {
      window.location.replace(
        `${process.env.REACT_APP_USER_MANAGEMENT_URL}/participant/home`
      );
    }
  }, []);
  return <div>Redirecting...</div>;
};

export default RedirectToParticipantHome;
